/**
 * Chat v1 contract (POST /api/chat). Shared by public-backend and the chat UI.
 * The server is stateless: the client sends at most 8 messages plus its current chips.
 */
export const CHAT_LOCALES = ['es', 'en', 'fi', 'sv'];
export const CHAT_RADII_M = [500, 1000, 2000, 5000];
export const CHAT_PRICE_BANDS = ['free', 'cheap'];
export const CHAT_KINDS = ['place', 'event'];
export const CHAT_ACTIONS = ['none', 'save_plan', 'navigate'];
export const CHAT_NEEDS = ['party', 'interests', 'budget', 'location'];
export const CHAT_UNSUPPORTED = ['open_now', 'child_age', 'step_free', 'dietary', 'date_window'];
//# sourceMappingURL=chat.js.map